import { Component, OnInit, AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef } from '@angular/core';


import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/service/shared/shared.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

import { IDropdownSettings } from 'ng-multiselect-dropdown';

import * as echarts from 'echarts';

import { ToastrService } from 'ngx-toastr'
import { ToastController } from '@ionic/angular';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ExtendDueDatePopupComponent } from 'src/app/shared/popups/extend-due-date-popup/extend-due-date-popup.component';
import { AddExpenseEmployeeComponent } from '../add-expense-employee/add-expense-employee.component';
import { formatText } from 'src/app/shared/commen-function-file';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.scss'],

})
export class ExpenseComponent implements OnInit {
  originalData: any[] = [];
  setupId: any;
  setupGradeBrand: any;
  public restrictToEditSetup: boolean = false;
  restrictToEditBandOrGrade: boolean = false;
  isSelectedYearIsSameYeartoCurrentYear: boolean = false;
  isInValidMaxRange: boolean = false;
  loggedInUserEmpCode: any;
  sleectedUserforCompetencySetup: any;
  showMaxRangeError: boolean = false;
  allowedToEditTeamCompetency: boolean = false;
  allowedToEditManagerMycompetency: boolean = false;
  errorMessage: string = '';
  reimbursementAdd: any;
  reimbursement: any;
  selectedEmployee: any;
  selectedDate: any;
  readonlyFlag = false;
  tableData: { scoreRange: string; maxRange: string; rating: string }[] = [];
  reimbursementTable: { reimbursementId: any, reimbursementType: string, band: any, amountLimit: any; }[] = [];
  editReimbursemendData: boolean = false;
  reimbursementAddId: any;
  reimbursementIDforEdit: any;

  columnVisibility: { [key: string]: boolean } = {
    function: true,
    band: true,
    competencyName: true,
    competencyDefinition: true,
    weightage: true,
    publishedOn: true,
    createdBy: true,
    lastModifiedBy: true
  };
  chartOptions: echarts.EChartsOption | undefined;

  selectedEmployeeDashboardId: any;



  comparisonEmpIdsForSecondLast: any = [];

  selectedEmpYearonYear: any = [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];


  setUpyearRange: any;
  loggedInCompanyMDCode: any;
  bandListData: any;
  getBandData: any;
  getLocationData: any;
  getAllFinanceUserDD: any;
  bandRecord: any;
  isLimitTypeLocked: boolean = false;
  showAddNewSaveBtn: boolean = true;
  getIndirectEmployees: any;
  selectedEmployeeIdForReport: any;
  completedTaskStatusCount: any;
  taskIsReviewByEmployee: any;
  sortName: any;
  sortBy: any;
  dWMReportTaskList: any;
  selectedTaskList: any = [];
  selectAllTaskCheckbox: boolean = false;
  reimbursementgetData: any;
  editableIndex: any;
  selectedManagerDashboardId: boolean = false;
  reimbursementTablefrontendSide: any;
  selectedKpiScoreSummaryfromDate: any;
  selectedKpiUser: any;
  EmployeeSummaryData: any = [];
  approveMatrixValueForCondition: any;
  selectedFinanceEmployee: any = [];
  deleteByReimbursementType: boolean = false;
  isShowEmployee: boolean = false;

  // Debugging function
  logColumnVisibility() {
  }

  onCheckboxChangeCheck(column: string, event: any) {
    this.columnVisibility[column] = event.checked;
    this.logColumnVisibility(); // Debugging call
  }

  checkboxState: { [key: string]: boolean } = {
    function: true,
    band: true,
    competencyName: true,
    competencyDefinition: true,
    weightage: true,
    publishedOn: true,
    createdBy: true,
    lastModifiedBy: true
  };

  competencyMapping: any = null;
  previousMaxRange: string = '0';
  showInputs: boolean = false;
  employeetotalweight: number[] = [];
  hradminCompetency: any[] = [];
  scoreRange: number | any;
  dropdownSettings: IDropdownSettings = {};
  maxRange: any = null;
  setupSubRatingId: any
  rating: string = '';
  ratings: string[] = [];
  isDuplicateRating: boolean = false;
  competencyYear: any;
  evaluationPeriod: any = null;
  editIndex: number | null = null;
  setupForm: boolean = false
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Dashboard'
  buttonColorName: any;
  subModuleButtonColor: any;
  showSetupPopup: boolean = false;
  showImportPopup: boolean = false;
  currentDate: any = new Date;
  competencyemployee: any = [];
  toDate: any;
  fromDate: any;
  selectedFunction: string = '';
  selectedBands: any[] = [];
  selectedBandForManager: string[] = [];
  uniqueFunctions: any[] = [];
  uniqueBands: any[] = [];
  competencySetupInformationForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  startItemhr: number = 0;
  endItemhr: number = 0;
  selectedYearForCompetency: any = null;
  selectedYearForGraphOneHRAdmin: any = null;
  editedIndex: number | null = null;
  editedEmployeeCommentIndex: number | null = null;
  selectedOption: string = 'Top';

  scoreRangeArray: any = [
    {
      companyId: null,
      id: null,
      maxRange: null,
      minRange: null,
      normalizeScore: null,
      pmsSetupId: null
    }
  ]
  loggedInCompanyFiscalyear: any;
  numbersOfDaysArray = Array.from({ length: 6 }, (_, i) => i + 1);
  wantLimit: string = '';                    // ngModel for 'Do You Want Limit?' radio buttons
  limitType: string = '';                    // ngModel for 'How Do You Want To At Limit?' radio buttons
  approveMatrix: string = '';
  selectedReimbursement: any;
  loggedInUserId: any;
  loggedInUserName: any
  loggedInUserRole: any;
  itemsdata: any;
  currentPageNumberOfKpis: any = 1;
  page: any = 0;
  loggedInUserRoles: any;
  loggedInUserRoleIsEmployee: boolean = false;
  pmsYears: any = [];
  getMonthsByFiscalandReviewCycle: any = [];
  fromYear: any = null;
  toYear: any = null;
  selectedItemsForPublish: Set<number> = new Set<number>();
  selectedItemsForDelete: Set<number> = new Set<number>();
  loggedInCompanyReviewCycle: any = null;
  deptListOfCompany: any;
  selectedDeptForKPISearch: any = null;
  goalSettingAtAllLevels: boolean = false;
  selectedYearReviewCycle: any;
  activeCustomReportBtn: boolean = false;
  isAllEmpForReportToggle: boolean = false;
  selectedGoalForEmp: any;
  selectedUserForKPIReport: any;
  activeReportBtnName: any = 'Scorecard';
  showTooltip: boolean = false;

  competencyListManagerView: any = []
  showFunction = true;
  showBand = true;
  showCompetencyName = true;
  showCompetencyDefinition = true;
  showWeightage = true;
  showPublishedOn = true;
  showCreatedBy = true;
  showLastModifiedBy = true;
  EditData = false;
  checkboxVisibility = {
    function: true,
    band: true,
    competencyName: true,
    competencyDefinition: true,
    weightage: true,
    publishedOn: true,
    createdBy: true,
    lastModifiedBy: true

  };

  reportBtn = [
    {
      isActive: true,
      btnName: 'Scorecard'
    },
    {
      isActive: false,
      btnName: 'All Employee -Month-YTD'
    },
    {
      isActive: false,
      btnName: 'KPI wise YTD'
    },
    {
      isActive: false,
      btnName: 'Review Compliance Report'
    },
    {
      isActive: false,
      btnName: 'Review Compliance Summary'
    },
    {
      isActive: false,
      btnName: 'Custom Report'
    },
  ]

  selectedTabIndex: number = 0
  constructor(public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef
  ) {
    this.scoreRange = '0';
  }

  ngOnInit() {

    this.cdRef.detectChanges();



    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }


    this.originalData = JSON.parse(JSON.stringify(this.competencyListManagerView));

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.getAllFunctionsByYearRangeReport();
    this.getpmsyearlist();
    this.getAllBand();
    this.getAllLocation();
    // this.getAllUserDD();

    this.getEmployee();
    // setTimeout(() => {

    //   this.getallReimbursementsForId();
    //   this.getallReimbursements();
    //   this.getAllEmployeesByDept();
    //   // this.getAllEmployeeListing();
    // }, 500)



  }

  formatedataVariable = formatText;
  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      // debugger

      var tab = params['tab'];
      if (tab === 'My Competency') {
        this.selectedTypeTabName = 'My Competency'
        this.selectedTypeTabIndex = 1;

      };

      if (params?.operation === 'Setup') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showSetupPopup = true;

          // this.getPmsYears();
        }
      } else if (params?.operation === 'import') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showImportPopup = true;
        }
      } else {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          // this.getDepartmentsByCompany();
        }
        else if (this.loggedInUserRole === 'Finance') {
          this.selectedManagerDashboardId = true; // Set up a manager-specific action
          // Call a manager-specific method if needed
        }

        else {
          this.selectedEmployeeDashboardId = this.loggedInUserId;
          // this.getUserByID();
        }

      }
    });
  }





  removeInputs() {
    this.showInputs = false;
    this.resetFormFields();
  }
  resetFormFields() {
    this.scoreRange = null;
    this.maxRange = null;
    this.rating = '';
    this.isInValidMaxRange = false;
  }


validateInput(event: any) {
  const inputValue = event.target.value;
  // Replace multiple spaces with a single space
  event.target.value = inputValue.replace(/\s+/g, ' ');
  this.reimbursementAdd = event.target.value;
}

 

  // Update Reimbursement Type
  updateReimbursementType(typeId:any) {
    
    
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => {
        this.currentreimbursementTable = result.data
        const currentreimbursementTable = result.data
      
        var isReimbursementTypeExist = this.currentreimbursementTable.some((elm: any) => elm.reimbursementType === this.updateReimbursmentType?.reimbursementType.trim());

        if (isReimbursementTypeExist) {
          this.showToast('Reimbursement type already exists', 'danger');
          return;  // Prevent further execution (i.e., saving)
        } else {
          var strReimbursementType = '';
          currentreimbursementTable.forEach((elm: any) => {
            if (elm.reimbursementId == typeId){
             strReimbursementType = elm.reimbursementType;
            }
          });
          
          currentreimbursementTable.forEach((elm:any)=>{
            if (strReimbursementType == elm.reimbursementType){
              this.reimbursement = {
                "reimbursementId": elm.reimbursementId,
                "reimbursementType": this.updateReimbursmentType?.reimbursementType,
                "changedByUserId": this.loggedInUserId,
                "hrAdminId": this.loggedInUserId,
                "year": this.selectedYearForCompetency
              }
              this.httpService.callPutService(`${this.config.updateReimbursement}`, this.reimbursement)
                .subscribe({
                  next: async (result: any) => {
    
                    await this.showToast(result.message, 'success');
                    // this.getallReimbursements();
                    this.resetEditingState()
                  },
                  error: async (err: any) => {
    
                    await this.showToast(err.error.message, 'danger');
                  }
                });

            }
            
          });
          
        }



      })


  }





  deleteSetup() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete these ratings?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {


      if (result) {


        if (this.setupId != null) {
          this.tableData = []
          this.reimbursementTable = [] = []
        } else {
          this.httpService.callGetService(this.config.deleteSetupTable + this.loggedInUserCompanyID + '/' + this.setupId)
            .subscribe(
              (response: any) => {
                this.loader.dismissLoader();

                const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'Items successfully deleted.',
                    btn2: 'OK',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false,
                  },
                });
                successdialogRef.afterClosed().subscribe(() => {

                });

              },
              (error: any) => {
              }
            );
        }
      }
    });
  }










  deleteCompetency() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const companyId = this.loggedInUserCompanyID;
        const selectedCompetencyIds = Array.from(this.selectedItemsForDelete);
        if (selectedCompetencyIds.length === 0) {
          return;
        }
        const request = {
          companyId: companyId,
          competencyIds: selectedCompetencyIds
        };
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.deleteCompetency, request).subscribe(
          (data: any) => {
            this.loader.dismissLoader();
            if (data?.success) {
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: data?.data,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              });
              successdialogRef.afterClosed().subscribe(() => {

                this.clearInputs();
                this.selectedItemsForPublish.clear();
                this.selectedItemsForDelete.clear();
              });
            } else {
              this.loader.dismissLoader();
            }
          },
          error => {
            this.loader.dismissLoader();
          }
        );
      }
    });
  }

  handleSubmit() {

    if (!this.isLastMaxRange100()) {
      this.errorMessage = 'The setup must include a max range of 100.';
      return;
    }
    if (!this.competencyMapping || !this.evaluationPeriod) {
      alert('Please select both Competency Mapping and Evaluation Period before submitting.');
      return;
    }
    // this.saveData();
    this.setCompetency();
  }



  setCompetency() {
    if (this.selectedTypeTabName == 'Dashboard') {
      this.sleectedUserforCompetencySetup = this.loggedInUserId;
    }
    const request = {
      competencyEvaluationPeriod: this.evaluationPeriod,
      companyId: this.loggedInUserCompanyID,
      rating: this.tableData.map(data => ({
        max: parseInt(data.maxRange, 10),
        min: parseInt(data.scoreRange, 10),
        rating: data.rating,
        companyId: this.loggedInUserCompanyID,
      })),
      selectCompetency: this.competencyMapping,
      "year": this.selectedYearForCompetency,
    };

    this.loader.simpleLoaderWithDuration();
    this.httpService.callPostService(this.config.competecnySetup, request).subscribe((data: any) => {
      this.loader.dismissLoader();
      if (data?.success) {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: data.data,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
        successdialogRef.afterClosed().subscribe(() => {
          this.router.navigate(['/home/hrportal/competency']);
        });
        this.clearInputs();
      }
    });
  }
  logEvaluationPeriod() {
  }
  logRadioSelection(value: string) {

    this.competencyMapping = value;


  }
  logInputChanges() {

  }

  CompetencyYear() {
    this.competencyYear = `${this.fromYear} - ${this.toYear}`;
  }



  resetCompetencySetup() {
    this.tableData = [];
    this.isLimitTypeLocked = false;
    this.restrictToEditBandOrGrade = false;
    this.restrictToEditSetup = false;
    this.setUpyearRange = null;
    this.evaluationPeriod = null;
    this.setupId = null;
    this.setupGradeBrand = null;
    this.competencyMapping = null;
  }

  deleteSetupRecords() {

  }


  toggleInputs() {

    this.reimbursementAdd = '';
    this.reimbursementIDforEdit = '';
    this.showInputs = !this.showInputs;
  }





  isLastMaxRange100(): boolean {
    // Ensure tableData is not empty
    if (this.tableData.length === 0) {
      return false;
    }

    // Get the maxRange of the last item in the tableData array
    const lastMaxRange = Number(this.tableData[this.tableData.length - 1].maxRange);

    // Return true if maxRange is 100, otherwise false
    return lastMaxRange === 100;
  }

  preventNegative(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  errMsgMaxRange: boolean = false;
  saveData() {


    // Check if reimbursementType already exists in the reimbursementTable
    // Check if the reimbursementType already exists in the reimbursementTable
    const isReimbursementTypeExist = this.reimbursementTable.some((elm: any) => elm.reimbursementType === this.reimbursementAdd.trim());

    // If it exists, show an error message and prevent saving the new reimbursement type
    if (isReimbursementTypeExist) {
      this.showToast('Reimbursement type already exists', 'danger');
      return;  // Prevent further execution (i.e., saving)
    } else {
      this.reimbursementTable.push({
        reimbursementId: null, // Use the selected reimbursementId for each band
        reimbursementType: this.reimbursementAdd, // Use the selected reimbursementType
        band: null,
        amountLimit: null
      });

      // If it does not exist, proceed to save the new reimbursement type
      this.saveNewReimbursement();


    }





    // Reset the input fields and hide the input section
    this.scoreRange = '';
    this.maxRange = null;
    this.rating = '';
    this.reimbursement = '';
    this.showInputs = false;
  }













  clearInputs() {
    this.scoreRange = '';
    this.maxRange = null;
    this.rating = '';
    this.reimbursementAdd = ""
  }



  editRow(index: number) {
    const entry = this.tableData[index];
    this.scoreRange = entry.scoreRange;
    this.maxRange = entry.maxRange;
    this.rating = entry.rating;
    this.editIndex = index;
    this.showInputs = true;
  }

  deleteRow(index: number) {
    this.tableData.splice(index, 1);
    this.reimbursementTable.splice(index, 1);


    this.clearInputs();
  }

  toggleTooltip() {
    this.showTooltip = !this.showTooltip;
  }





  onClickImport(operation: any) {
    this.router.navigate(['/home/hrportal/competency', { operation: operation }]);
  }



  onClickBreadcrumExpence() {
    this.router.navigate(['/home/hrportal/expense']);

  }



  setup() {
    this.setupForm = true;
  }
  isReimbursementInvalid(item: any): boolean {


    const invalid = this.bandListData.some(
      (band: any) => band.reimbursementId === null
    );
    console.log(`Checking item:`, item, `Result:`, invalid); // Debugging
    return invalid;
  }





  // *****************Get  competeny year***********
  isReimbursementType = false;

  // getpmsyearlist() {

  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];


  //     this.isReimbursementType = false;

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       }
  //       this.pmsYears.push(obj);
      
  //     });
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }

  //      /*  if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`;


  //       } else {
  //         yearValue = `${currentYear}-${currentYear + 1}`;

  //       } */
  //       // debugger
  //       if (ele?.year == yearValue) {
  //         this.selectedYearForCompetency = ele?.year;
  //         this.selectedYearForGraphOneHRAdmin = ele?.year
  //         this.selectedYearForGraphTwoHRAdmin = ele?.year
  //         this.selectedYearForGraphFifthHRAdmin = ele?.year
  //         this.selectedYearForGraphSix = ele?.year
  //         this.selectedYearForGraphNineHRAdmin = ele?.year
  //         this.selectedYearForGraphTenHRAdmin = ele?.year
  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
  //     });
  //     //     this.getMonths(this.fromYear, this.toYear);
  //     // this.getEmployeeUnderManager()

  //     // this.getBandDataFunction();

  //     if (this.selectedTypeTabName === 'My Competency') {

  //     } else if (this.selectedTypeTabName === 'Competency Master') {
  //       ;
  //     }
  //     else if (this.selectedTypeTabName === 'Team Competency') {
  //       // this.getCompetencyByManagerTeamList();
  //     }
  //     // this.getDepartmentsByCompany();
  //     if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
  //       || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
  //       // this.getManagerListDashboard();
  //     }
  //     this.getallReimbursementsForId();
  //     this.getallReimbursements();
  //     this.getAllEmployeesByDept();
  //     this.getAllUserDD();
  //   })
  // }


    getpmsyearlist() {
      this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
        this.pmsYears = formatYearRanges(data?.data?.yearRanges);
  
        const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
  
        const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
        
        this.setSelectedYear(yearValue);

      });
    }
    setSelectedYear(yearValue: string): void {
      const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
      if (selectedYearObj) {
            this.selectedYearForCompetency = selectedYearObj?.year;
            this.selectedYearForCompetency = selectedYearObj?.year;
          this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year
          this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year
          this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year
          this.selectedYearForGraphSix = selectedYearObj?.year
          this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year
          this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year
            let test = selectedYearObj?.year.split('-');
            this.fromYear = test[0];
            this.toYear = test[1];
      }
      this.getallReimbursementsForId();
      this.getallReimbursements();
      this.getAllEmployeesByDept();
      this.getAllUserDD();
    }
  /********************************** */

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;


  }
  
  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/expense', { operation: operation }]);
    this.getallReimbursements();
    
  }

  getIndividualBandList: any = [];
  ScoreToFinalScoreConverterPlusCompanyScore: any = [];
  isInValidMaxIndividualKpi = false;
  isInValidMinIndividualKpi = false;
  isInValidMaxIndividualCompetency = false
  isInValidMinIndividualCompetency = false
  IsIndividualTotalWeightage = false
  InvalidIndividualCompetencyMaxTW = false;
  InvalidIndividualCompetencyMinTW = false;
  InvalidDepthKpiMaxScore = false;
  InvalidDepthKpiMinScore = false;
  InvalidcompanyKpiScoreMaxScore = false
  InvalidcompanyKpiScoreMinScore = false;
  InvalidcompanyscoreWT = false;
  editedIndividualScoreId: number | null = null;
  IncrementGridBandList: any = [];
  onCheckIconView: boolean = true;
  isFormDisabled: boolean = false;
  disableIncrementInputFormToHOD: any;
  disableIncrementInputFormToHrAdmin: any;
  reimbursementBandId: any;

  disableIncrementSetupAfterChangeYear: any
  getBandDataFunction() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
    }
    this.httpService.callPostService(this.config.getBandListForIncrement, request).subscribe((result: any) => {
      this.getIndividualBandList = result.data.map((data: any) => ({
        band: data,
        companyKpiScore: null,
        deptKpiScore: null,
        id: null,
        individualCompetencyWeightage: null,
        individualKpiScoreWeightage: null,
        totalWeightage: null,
        location: null,
        limit: null
      }));


      this.ScoreToFinalScoreConverterPlusCompanyScore = result.data.map((data: any) => ({
        band: data,
        companyKpiScore: null,
        deptKpiScore: null,
        id: null,
        individualCompetencyWeightage: null,
        individualKpiScoreWeightage: null,
        totalWeightage: null
      }));
      // debugger
      this.IncrementGridBandList = result.data.map((data: any) => ({
        band: data,
        id: [],
        incrementPercentage: [],
      }));

    });
  }

  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/expense-logs', { moduleName: moduleName, id: 0 }]);
  }
  deleteReImbursement(event: any, index: number) {
  console.warn("deleteReImbursement")

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete these Reimbursement Types?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {

        this.httpService
          .callDeleteService(`${this.config.reimbursementsType}/${event}`)
          .subscribe(
            () => {
              // API call successful, even if result is empty


              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'Items successfully deleted.',
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              });

              successdialogRef.afterClosed().subscribe(() => {
                this.deleteByReimbursementType = this.reimbursementTable.length == 1 ? false : true;
                console.log("successdialogRef")
                console.log(this.reimbursementTable.length)
                this.clearReimbursementData(); // Clear data and fetch updated data
                this.getallReimbursements(); // Fetch the updated list
                
              });
            },
            (error: any) => {
              // Handle error case
              console.error('Deletion failed:', error);

              // Optional: Show error dialog
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'Items successfully deleted.',
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              });
              this.getallReimbursements(); // Fetch the updated list
              this.getAllEmployeeListing();

            }
          );
      }


    });
  }

  // Helper function to clear reimbursement data
  clearReimbursementData() {
    this.reimbursementTable = [];
    this.reimbursementgetData = [];
    this.selectedReimbursement = '';
    this.reimbursementAdd = '';
    // Additional clearing logic if required
  }


  onSaveIndividualScoreToFinalScoreConverter() {
    let finalarray: any = [];
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "incrementSetupId": null,
      "scores": this.getIndividualBandList,
      "toYear": this.toYear
    }

    finalarray.push(request)


    if (this.IsIndividualTotalWeightage || this.isInValidMaxIndividualKpi || this.isInValidMinIndividualKpi || this.isInValidMaxIndividualCompetency || this.isInValidMinIndividualCompetency) {
      window.alert("error")
      return;
    } else {
      this.httpService.callPostService(this.config.incrementScoreToFinalScoreConverter, request)
        .subscribe((result: any) => {
        });
      this.editedIndividualScoreId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false
    }
  }

  getScoreToFinalConverterIndividual() {

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    this.getallReimbursements();
  }
  onClickIndividualScoreEdit(itemId: number): void {

    this.onReimbursementIdChange(this.selectedReimbursement);
    if (this.disableIncrementInputFormToHrAdmin == true || this.disableIncrementSetupAfterChangeYear == true) {
      this.editedIndividualScoreId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false
    } else {
      this.editedIndividualScoreId = itemId;
      this.onCheckIconView = true;
      this.isFormDisabled = false
    }


  }

  fitergetAllFinanceUserDD: any = [];
  filterForFinance: any = [];
  isFinanceLoginUser = false;
  getAllUserDD() {
    // http://192.168.0.97:8085/api/reimbursement/getAllEmployees/
    this.httpService.callGetService(`${this.config.getAllEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {

        this.getAllFinanceUserDD = result.data.users;

        setTimeout(() => {

          if (this.fetchFinanceReimbursements && this.getAllFinanceUserDD) {
            // Flatten fetchFinanceReimbursements if it's nested
            const flattenedReimbursements = this.fetchFinanceReimbursements.flat()
            // Filter users based on matching IDs
            const matchingUsers = this.getAllFinanceUserDD.filter((user: { id: number; }) =>
              flattenedReimbursements.includes(user.id)
            );
            //  matchingUsers


            this.filterForFinance = matchingUsers.filter((elm: any) => elm.id == this.loggedInUserId);


            let data = this.filterForFinance.map((elm: any) => elm.id);



            if (data.length > 0) {
              this.isFinanceLoginUser = true;
              console.log("HELLOOOO");
            }

            sessionStorage.setItem('financeAdminId', data[0]);


          } else {
            console.error("Data is missing or undefined.");
          }
        }, 700);
      });
  }
  onSelectionChangeLimit(event: any) {

    this.selectedReimbursement = null;

    this.onSelectionChange(this.selectedReimbursement);
  }
  onSelectionChange(event: any) {


    if (this.limitType == 'Band') {
      this.bandListData = this.getBandData?.map((data: any) => ({
        band: data,
        companyKpiScore: null,
        reimbursementId: null,
        location: null,
        limit: null,

      }));
    } else if (this.limitType == 'Location') {
      this.bandListData = this.getLocationData?.map((data: any) => ({
        band: null,
        companyKpiScore: null,
        reimbursementId: null,
        location: data,
        limit: null
      }));
    }
    else {
      this.bandListData = [
        {
          band: null,
          companyKpiScore: null,
          reimbursementId: null,
          location: null,
          limit: null
        }
      ];
    }



  }

  reimbursmentIDForNo: any = [];
  onSelectionChangeForWantLimit(value: any): void {


    if (value === 'no') {
      
      // Validate `approveMatrix` and `selectedEmployee`
      if (!this.approveMatrix) {

        this.showToast("Approve matrix is required", 'danger');
        this.revertSelection();
        return;
      }

      if (this.selectedEmployee.length == 0) {
        this.showToast("Finance Admin is required", 'danger');
        this.revertSelection();
        return;
      }


    }

    if (value === 'yes') {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: `Are you sure you want to select "${value}"?`,
          btn2: 'Yes',
          btn1: 'No',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });

      dialogRef.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          this.wantLimit = value;
        } else {
          this.revertSelection();
        }
      });
    } else {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: `Are you sure you want to select "${value}"?`,
          btn2: 'Save',
          btn1: 'Cancel',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });

      dialogRef.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          this.wantLimit = value;

          this.reimbursmentIDForNo = this.reimbursementTable.map((elm: any) => ({
            reimbursementId: elm.reimbursementId,
            financeAccessEmployeeIds: this.selectedEmployee,
            approvedMatrix: this.approveMatrix,
            year: this.selectedYearForCompetency,
            fiscal_year: this.loggedInCompanyFiscalyear,
            setLimit: false,
          }));

          this.reimbursmentIDForNo.forEach((element: any) => {
            this.httpService
              .callPutService(`${this.config.updreimbursement}`, element)
              .subscribe({
                next: async (result: any) => {
                  await this.showToast(result.message, 'success');
                  this.getallReimbursements();
                  this.resetEditingState();
                  this.wantLimit = 'no';
                  this.isLimitTypeLocked = true;
                },
                error: async (err: any) => {
                  await this.showToast(err.error.message, 'danger');
                },
              });
          });


        } else {
          this.revertSelection();
        }
      });
    }
  }

  private revertSelection(): void {
    // Reset the `wantLimit` to its previous value
    setTimeout(() => {
      this.wantLimit = ''; // Ensure the UI reflects the reset value
    });
  }

  individualRowData: any;
  IndividualTotalWeightage(item: any) {

    this.individualRowData = item;


  }

  getAllBand() {
    this.httpService.callGetService(`${this.config.getBandsByCompanyForSetUP}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        this.getBandData = result.data;
        this.bandRecord = result.data;
      });
  }

  getAllLocation() {
    this.httpService.callGetService(`${this.config.getWorkLocationStateByCompany}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        this.getLocationData = result.data;

      });
  }
  editReImbursement(event: any, i: any) {
    this.EditData = true;
    this.editableIndex = i;
    this.reimbursementIDforEdit = event.reimbursementId;


  }
  closeEditing(): void {
    
    this.deleteByReimbursementType = this.reimbursementTable.length == 0 ? false : true;
    this.resetEditingState();
    this.getallReimbursements();
  }
  resetEditingState(): void {
    this.showInputs = false;
    this.EditData = false;
    this.editableIndex = null;
  }

  handleReimbursementClick(reimbursementId: any, i: any): void {


    if (i == 0) {
      // Call update-save function if reimbursementAddId exists
      this.updatesaveReimbursement();
    } else if (reimbursementId !== null) {
      // Call update function if item.reimbursementId exists
      this.updateReimbursement();
    } else {
      // Call save function if neither exists
      this.saveReimbursement();
    }
  }


  saveReimbursement() {

    if (!this.approveMatrix) {
      this.showToast("Approve matrix is required", 'danger');
      return;
    } else if (this.selectedEmployee == 0) {
      this.showToast("Finance admin is required", 'danger');
      return;
    }

    const remData = this.reimbursementTable.filter((elm: any) => elm.reimbursementId == this.selectedReimbursement);

    let formData = {
      "companyId": this.loggedInUserCompanyID,
      "hrAdminId": parseInt(this.loggedInUserId),
      "reimbursementType": remData[0]?.reimbursementType,
      "setLimit": true,
      "limitType": this.limitType,
      // "reimbursementId": this.individualRowData.reimbursementId,
      "band": this.individualRowData?.band,
      "location": this.individualRowData.location ? this.individualRowData.location : null,
      "amountLimit": this.individualRowData.limit ? this.individualRowData.limit : (this.individualRowData.limit == 0) ? 0 : null,
      "approvedMatrix": this.approveMatrix,
      "financeAccessEmployeeIds": this.selectedEmployee,
      "year": this.selectedYearForCompetency,
      "fiscal_year": this.loggedInCompanyFiscalyear,
    }

    this.httpService.callPostService(`${this.config.reimbursement}`, formData)
      .subscribe({
        next: async (result: any) => {
          await this.showToast(result.message, 'success');
          this.getallReimbursements();
          // this.getCompetencySetup();

        },
        error: async (err: any) => {

          await this.showToast(err.error.message, 'danger');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;

  }


  updatesaveReimbursement() {

    if (!this.approveMatrix) {
      this.showToast("Approve matrix is required", 'danger');
      return;
    }
    if (this.selectedEmployee.length === 0) {
      this.showToast("Finance admin is required", 'danger');
      return;
    }


    const remData = this.reimbursementTable.filter((elm: any) => elm.reimbursementId == this.selectedReimbursement);
 
    let formData = {
      "companyId": this.loggedInUserCompanyID,
      "hrAdminId": parseInt(this.loggedInUserId),
      "reimbursementType": remData[0]?.reimbursementType,
      "setLimit": true,
      "reimbursementId": this.selectedReimbursement,
      "band": (this.individualRowData == undefined) ? null : this.individualRowData?.band,
      "location": this.individualRowData?.location ? this.individualRowData?.location : null,
      "amountLimit": this.individualRowData?.limit ? this.individualRowData?.limit : (this.individualRowData.limit == 0) ? 0 : null,
      "approvedMatrix": this.approveMatrix,
      "financeAccessEmployeeIds": this.selectedEmployee,
      "limitType": this.limitType,
      "year": this.selectedYearForCompetency,
      "fiscal_year": this.loggedInCompanyFiscalyear,

    }
  

    this.httpService.callPutService(`${this.config.updreimbursement}`, formData)
      .subscribe({
        next: async (result: any) => {

          await this.showToast(result.message, 'success');
          this.getallReimbursements();


        },
        error: async (err: any) => {

          await this.showToast(err.error.message, 'danger');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;

  }

  confirmSelection(item: any, event: Event): void {
    this.reimbursmentIDForNo = this.reimbursementTable.map((elm: any) => ({
      reimbursementId: elm.reimbursementId,
      financeAccessEmployeeIds: this.selectedEmployee,
      approvedMatrix: this.approveMatrix,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      changedByUserId: this.loggedInUserId,
      hrAdminId: this.loggedInUserId
    }));

    const isAlreadySelected = this.selectedEmployee.includes(item.id);

    if (!this.selectedFinanceEmployee.includes(item.id)) {
      this.selectedFinanceEmployee.push(item.id); // Add the employee if not already selected
    }

    event.stopPropagation(); // Prevent default selection behavior temporarily

    // Open the confirmation dialog
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: isAlreadySelected
          ? 'Do you really want to select this Finance Admin?'
          : 'Do you really want to unselect this Finance Admin?',
        btn1: 'No',
        btn2: 'Yes',
      },
    });

    // Handle the result of the dialog
    dialogRef.afterClosed().subscribe((result) => {
      console.error(isAlreadySelected);

      if (result === true) {
        
        // Add the item ID to selectedEmployee if confirmed
        if (!this.selectedEmployee.includes(item.id)) {
          this.selectedEmployee.push(item.id); // Add the employee
        }

        if (this.allreadySellectedFinanceAdmin.length) {
          this.reimbursmentIDForNo.forEach((element: any) => {
            this.httpService.callPutService(`${this.config.updateReimbursement}`, element)
              .subscribe({
                next: async (result: any) => {
                  await this.showToast(result.message, 'success');
                  this.getallReimbursements();
                  this.resetEditingState();
                },
                error: async (err: any) => {
                  await this.showToast(err.error.message, 'danger');
                },
              });
          });
        }
      } else if (result === false && !isAlreadySelected) {
        console.error(this.selectedFinanceEmployee);
        
        // this.selectedEmployee = this.selectedFinanceEmployee.filter((id: any) => id == item.id);
        this.selectedEmployee = this.selectedFinanceEmployee;
        console.error(this.selectedEmployee);
        // Do nothing if the item is unselected and "No" is clicked
        console.log('No action taken on unselect');
      } else {
        // Remove the item ID from selectedEmployee if the user cancels
        this.selectedEmployee = this.selectedEmployee.filter((id: any) => id !== item.id);
        console.log('Action Cancelled');
      }

      this.cdRef.detectChanges(); // Force change detection
    });
  }

  reimbursementsArray: { reimbursementId: number, reimbursementType: string }[] = [];

  saveNewReimbursement() {


    this.reimbursement = {
      // "reimbursementType": this.reimbursementAdd,
      "reimbursementId": this.reimbursementIDforEdit || null,
      "reimbursementType": this.reimbursementAdd.trim() || this.updateReimbursmentType.reimbursementType.trim(),
      "year": this.selectedYearForCompetency,
      "fiscal_year": this.loggedInCompanyFiscalyear,
      "companyId": this.loggedInUserCompanyID,
      "hrAdminId": parseInt(this.loggedInUserId),

    }

    // return;
    this.httpService.callPostService(`${this.config.onlyreimbursementType}`, this.reimbursement)
      .subscribe({
        next: async (result: any) => {
          console.error(result)
          await this.showToast(result.message, 'success');

          this.reimbursementAddId = result.data.reimbursementId;


          this.reimbursementBandId = result.data.reimbursementId;
          if (result.status && result.data) {
            this.reimbursementsArray.push({
              reimbursementId: result.data.reimbursementId,
              reimbursementType: result.data.reimbursementType,
            });

            if (this.wantLimit == 'no') {
              const UpdateData = {
                reimbursementId: this.reimbursementAddId,
                financeAccessEmployeeIds: this.selectedEmployee,
                approvedMatrix: this.approveMatrix,
                year: this.selectedYearForCompetency,
                fiscal_year: this.loggedInCompanyFiscalyear,
                setLimit: false,
              }

                this.httpService
                .callPutService(`${this.config.updreimbursement}`, UpdateData)
                .subscribe({
                  next: async (result: any) => {
                    await this.showToast(result.message, 'success');
                    this.getallReimbursements();
                    this.resetEditingState();
                    this.wantLimit = 'no';
                    this.isLimitTypeLocked = true;
                  },
                  error: async (err: any) => {
                    await this.showToast(err.error.message, 'danger');
                  },
                });



            }
            this.getallReimbursementsForId();
          }

        },
        error: async (err: any) => {

          await this.showToast(err.error.message, 'danger');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    this.resetEditingState();

  }

  async showToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color,
      position: 'top'
    });
    await toast.present();
  }

  getallReimbursementsForIdforType() {
    // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => { })
  }

  fetchFinanceReimbursements: any = [];
  currentreimbursementTable: any = [];

  getallReimbursementsForId() {
    // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => {
        const getData = result.data[0];

        this.currentreimbursementTable = result?.data
        this.selectedReimbursement = getData?.reimbursementId;

        if (this.limitType == 'Band') {

          this.reimbursementgetData = result.data.filter((elm: any) => elm.band != null);
          this.reimbursementTable = result?.data
            .filter((elm: any) => elm)
            .reduce((acc: any[], current: any) => {
              if (!acc.some((item) => item.reimbursementType === current.reimbursementType)) {
                acc.push(current);
              }
              return acc;
            }, []);
        } else if (this.limitType == 'Location') {
          this.reimbursementgetData = result?.data.filter((elm: any) => elm.location != null);
          this.reimbursementTable = result?.data
            .filter((elm: any) => elm)
            .reduce((acc: any[], current: any) => {
              if (!acc.some((item) => item?.reimbursementType === current.reimbursementType)) {
                acc.push(current);
              }
              return acc;
            }, []);
        } else {
          this.reimbursementgetData = result?.data.filter((elm: any) => elm.location == null && elm.band == null);

          this.reimbursementTable = result?.data.filter((elm: any) => elm.location == null && elm.band == null);
        }
      })
  }
  handalemployeToFinanceCondition: any = []
  getallReimbursements() {
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
      .subscribe({
        next: (result: any) => {

          let arrAllReimbursement = result.data.filter((elm: any) => elm.setLimit === true);
          let arrAllReimbursementForFalse = result.data.filter((elm: any) => elm.setLimit === false);


          this.handalemployeToFinanceCondition = (arrAllReimbursement[0]?.approvedMatrix) ? arrAllReimbursement[0]?.approvedMatrix : result?.data[0]?.approvedMatrix;

          let approvedMatrix = result.data.filter((elm: any) => elm.approvedMatrix);

          
          
          this.approveMatrixValueForCondition = this.handalemployeToFinanceCondition;

          this.httpService.passApprovematrixForReport = this.approveMatrixValueForCondition;

          this.empReimbursementTable();

          if (result.data.length > 0) {
            
            if (arrAllReimbursement.length > 0) {
              this.wantLimit = 'yes';
              this.isLimitTypeLocked = true;
            } else if (arrAllReimbursementForFalse.length > 0) {
              this.wantLimit = 'no';
              this.approveMatrix = this.handalemployeToFinanceCondition;
              this.isLimitTypeLocked = true;

            }

          } else {
            this.wantLimit = '';
            this.limitType = '';
            this.approveMatrix = '';
            this.isLimitTypeLocked = false;
            this.selectedReimbursement = null;
          }
          // this.reimbursementTable=[];

      /*     if (result.data[0]?.band == null && result.data[0]?.location == null && (result.data[0]?.limitType != 'Neither' || result.data[0]?.limitType != 'band' || result.data[0]?.limitType != 'location')) {
            this.reimbursementAddId = result.data[0]?.reimbursementId;
          } */

          this.reimbursementgetData = [];
          if (result.data[0]?.band == null && result.data[0]?.location == null && result.data[0]?.limitType == 'Neither') {


            this.reimbursementAddId = result.data[0]?.reimbursementId;

            const getData = result.data[0];

            this.approveMatrix = this.handalemployeToFinanceCondition;
            this.selectedEmployee = arrAllReimbursement[0]?.financeAccessEmployeeIds || [];
            this.limitType = arrAllReimbursement[0]?.limitType,
              this.httpService.limitTypes = this.limitType;
          } else if (arrAllReimbursement[0]?.band != null || arrAllReimbursement[0]?.location != null) {

            const getData = result.data[0]; // This is the first item in the array
            this.approveMatrix = this.handalemployeToFinanceCondition;
            this.selectedEmployee = arrAllReimbursement[0]?.financeAccessEmployeeIds || [];
            this.limitType = arrAllReimbursement[0]?.limitType
            this.httpService.limitTypes = this.limitType;
          }
          else if (arrAllReimbursementForFalse[0]?.setLimit == false) {
            this.approveMatrix = this.handalemployeToFinanceCondition;
          } else {
            this.reimbursementAddId = result.data[0]?.reimbursementId;
          }

          // this.selectedReimbursement = getData?.reimbursementType;

          if(!this.deleteByReimbursementType){

            const financeAdmin = result?.data.map((elm: any) => elm.financeAccessEmployeeIds);
            this.financeAdmindb = result?.data.map((elm: any) => elm.financeAccessEmployeeIds);
            this.allreadySellectedFinanceAdmin = this.financeAdmindb.flat();
  
            this.selectedEmployee = financeAdmin.flat();
  
  
            this.selectedEmployee = [...new Set(financeAdmin.flat())]; // Remove duplicates using Set
          }

          // Check if already present in fetchFinanceReimbursements to avoid duplicate pushes
          if (!this.fetchFinanceReimbursements.some((item: any) => JSON.stringify(item) === JSON.stringify(this.selectedEmployee))) {
            this.fetchFinanceReimbursements.push(this.selectedEmployee);
          }

          this.onSelectionChange(this.limitType);

          if (this.limitType == 'Band') {

            this.reimbursementgetData = result.data;
            // this.reimbursementgetData = result.data.filter((elm: any) => elm.band != null );

            this.reimbursementTable = result.data
              .filter((elm: any) => elm)
              .reduce((acc: any[], current: any) => {
                if (!acc.some((item) => item.reimbursementType === current.reimbursementType)) {
                  acc.push(current);
                }
                return acc;
              }, []);


            this.onReimbursementIdChange(this.selectedReimbursement);
          } else if (this.limitType == 'Location') {

            this.reimbursementgetData = result?.data.filter((elm: any) => elm);

            this.reimbursementTable = result?.data
              .filter((elm: any) => elm)
              .reduce((acc: any[], current: any) => {
                if (!acc.some((item) => item?.reimbursementType === current.reimbursementType)) {
                  acc.push(current);
                }
                return acc;
              }, []);

            this.onReimbursementIdChange(this.selectedReimbursement);
          } else {
            this.reimbursementgetData = result?.data.filter((elm: any) => elm);

            // this.reimbursementTable = result?.data.filter((elm: any) => elm.location == null && elm.band == null);
            this.reimbursementTable = result?.data
              .filter((elm: any) => elm.location == null && elm.band == null)
              .reduce((acc: any[], current: any) => {
                if (!acc.some((item) => item?.reimbursementType === current.reimbursementType)) {
                  acc.push(current);
                }
                return acc;
              }, []);
            this.onReimbursementIdChange(this.selectedReimbursement);
          }


          this.getAllEmployeeListing();

        },
        error: (err) => {
          console.error("Error fetching reimbursement data:", err);
        }

      });

  }

  selectedReimbursementPID: any;
  onReimbursementIdChange(selectedId: any) {

    console.log("onReimbursementIdChange");

    if (this.limitType == 'Location' || this.limitType == 'Band') {
      this.reimbursementAddId = '';
    }
    this.selectedReimbursement = selectedId;
    this.editReimbursemendData = true;

    const remData = this.reimbursementTable.filter((elm: any) => elm.reimbursementId == this.selectedReimbursement);
    const findBandAndReimbursment = this.reimbursementgetData.filter(
      (item: any) => item?.reimbursementType === remData[0]?.reimbursementType
    );





    if (findBandAndReimbursment.length > 0) {

      const updatedBandListData = this.bandListData.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = findBandAndReimbursment.find((data: any) => data.band === bandData.band);

        // Update the limit for the matching band or set it to null for non-matching bands

        return {
          ...bandData,
          selectedEmployee: matchingBand ? matchingBand.financeAccessEmployeeIds : null,
          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });

      const updatedLocationListData = this.bandListData.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = findBandAndReimbursment.find((data: any) => data.location === bandData.location);
        // Update the limit for the matching band or set it to null for non-matching bands
        return {
          ...bandData,

          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });

      const updatedNeitherListData = findBandAndReimbursment.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = findBandAndReimbursment.find((data: any) => data.location === null && data.band === null && data.amountLimit != null);
        // Update the limit for the matching band or set it to null for non-matching bands
        return {
          ...bandData,

          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });




      // Case when limitType is 'Band' and selectedReimbursement has amountLimit
      if (this.limitType === 'Band' && findBandAndReimbursment.amountLimit !== null) {
        this.reimbursementAddId = '';
        this.bandListData = updatedBandListData;

      }

      else if (this.limitType === 'Location' && findBandAndReimbursment.amountLimit !== null) {
        this.reimbursementAddId = '';
        this.bandListData = updatedLocationListData;
      }
      else if (findBandAndReimbursment.amountLimit !== null) {

        this.bandListData = updatedNeitherListData
        // Case when reimbursementId is null, handle accordingly

      } else { }

    }
  }


  allreadySellectedFinanceAdmin: any = [];
  financeAdmindb: any = [];
  updateBandListData(allData: any, Reimbursements: any, bandlistdata: any[]) {

    if (Reimbursements.length > 0) {
      const updatedBandListData = bandlistdata.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = Reimbursements.find((data: any) => data.band === bandData.band);

        // Update the limit for the matching band or set it to null for non-matching bands

        return {
          ...bandData,
          selectedEmployee: matchingBand ? matchingBand.financeAccessEmployeeIds : null,
          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });

      const updatedLocationListData = bandlistdata.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = Reimbursements.find((data: any) => data.location === bandData.location);
        // Update the limit for the matching band or set it to null for non-matching bands
        return {
          ...bandData,

          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });

      const updatedNeitherListData = bandlistdata.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = Reimbursements.find((data: any) => data.location === null && data.band === null);
        // Update the limit for the matching band or set it to null for non-matching bands
        return {
          ...bandData,

          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });
      // Case when limitType is 'Band' and selectedReimbursement has amountLimit
      if (this.limitType === 'Band' && Reimbursements.amountLimit !== null) {
        this.bandListData = updatedBandListData;
      }

      else if (this.limitType === 'Location' && Reimbursements.amountLimit !== null) {
        this.bandListData = updatedLocationListData;
      } else {
        this.bandListData = updatedNeitherListData
        // Case when reimbursementId is null, handle accordingly

      }

    }


  }

  updateReimbursmentType: any;
  updateSpecificreimbursmentType(event: any) {
    console.log(event)
    this.updateReimbursmentType = event;
  }

  updateReimbursement() {



    this.reimbursement = {
      "amountLimit": this.individualRowData?.limit ? this.individualRowData?.limit : (this.individualRowData.limit  == 0) ? 0 :null,
      "financeAccessEmployeeIds": this.selectedEmployee,
      "reimbursementId": this.individualRowData?.reimbursementId || this.reimbursementIDforEdit || this.bandListData[0].reimbursementId,
      "reimbursementType": this.updateReimbursmentType?.reimbursementType ? this.updateReimbursmentType?.reimbursementType : null,
      "changedByUserId": this.loggedInUserId,
      "hrAdminId": this.loggedInUserId,
      "year": this.selectedYearForCompetency
    }

    this.httpService.callPutService(`${this.config.updateReimbursement}`, this.reimbursement)
      .subscribe({
        next: async (result: any) => {


          await this.showToast(result.message, 'success');
          this.getallReimbursements();
          this.resetEditingState()
        },
        error: async (err: any) => {


          await this.showToast(err.error.message, 'danger');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }

  updateReimbursementForNo() {

    this.reimbursement = {
      "amountLimit": this.individualRowData?.limit ? this.individualRowData?.limit : null,
      "financeAccessEmployeeIds": this.selectedEmployee,
      "reimbursementId": this.individualRowData?.reimbursementId || this.reimbursementIDforEdit || this.bandListData[0].reimbursementId,
      "reimbursementType": this.updateReimbursmentType?.reimbursementType ? this.updateReimbursmentType?.reimbursementType : null,
      "changedByUserId": this.loggedInUserId,
      "hrAdminId": this.loggedInUserId
    }
    this.httpService.callPutService(`${this.config.updateReimbursement}`, this.reimbursement)
      .subscribe({
        next: async (result: any) => {


          await this.showToast(result.message, 'success');
          this.getallReimbursements();
          this.resetEditingState()
        },
        error: async (err: any) => {


          await this.showToast(err.error.message, 'danger');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }
  // Year 

  getYearSetupForReimbursement() {
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {
        const selectedYear = this.selectedYearForCompetency.split('-')[0];


        if (elm.data.length > 0) {

          this.getallReimbursementsForId();
          this.getallReimbursements();
          // this.onReimbursementIdChange('oo');

        } else {

          this.isLimitTypeLocked = false;
          this.approveMatrix = '';
          this.wantLimit = '';
          this.limitType = '';
          this.selectedReimbursement = '';
          this.selectedEmployee = [];
          this.bandListData = [];
          this.reimbursementTable = []
        }

        if (selectedYear != new Date().getFullYear()) {


          this.isReimbursementType = true;
          this.isLimitTypeLocked = true;
        } else {
          this.isReimbursementType = false;
        }

      })


  }


  // ---------------------------------Employee Login -------------------------------------------
  taskColumnHeaderInfo: any[] = [];

  taskColumnHeaderInfoForManager: any[] = [];
  taskColumnHeaderInfoForFinanse: any = [];
  empReimbursementTable() {
    const commonColumns = [
      { label: 'Reimbursement type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'date' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'attachdocumentproof' },
      { label: 'Status', isMandatory: true, sortingName: 'status' },
      { label: 'Employee comment', isMandatory: false, sortingName: 'employeeComment' },
      { label: 'Finance comment', isMandatory: false, sortingName: 'financeComment' },
      { label: 'Approved Status', isMandatory: true, sortingName: 'approvedStatus' },
      { label: 'Action', isMandatory: false },
    ];

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = { label: 'Manager comment', isMandatory: false, sortingName: 'managerComment' };
      const employeeCommentIndex = commonColumns.findIndex(column => column.sortingName === 'employeeComment');
      commonColumns.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }
    
    this.taskColumnHeaderInfo = commonColumns;


    const taskColumnHeaderInfoForManager = [
      { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
      { label: 'Reimbursement type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'startDate' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      // { label: 'Reimbursement Id', isMandatory: true, sortingName: 'reimbursementId' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: 'actualAmountByFinance' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'attachDocumentProof' },
      { label: 'Status', isMandatory: true, sortingName: 'status' },
      { label: 'Employee comment', isMandatory: false, sortingName: 'employeeComment' },
      { label: 'Finance comment', isMandatory: false, sortingName: 'financeComment' },
      { label: 'Approval', isMandatory: true, sortingName: 'approvalStatus' },
      { label: 'Action', isMandatory: false } // No sortingName needed for actions
    ];
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = { label: 'Manager comment', isMandatory: false, sortingName: 'managerComment' };
      const employeeCommentIndex = taskColumnHeaderInfoForManager.findIndex(column => column.sortingName === 'employeeComment');
      taskColumnHeaderInfoForManager.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }

    this.taskColumnHeaderInfoForManager = taskColumnHeaderInfoForManager;

    console.log(this.approveMatrixValueForCondition);

    const taskColumnHeaderInfoForFinanse = [
      { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
      { label: 'Reimbursement type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'startDate' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: 'actualAmountByFinance' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'attachDocumentProof' },
      { label: 'Status', isMandatory: true, sortingName: 'status' },
      { label: 'Employee comment', isMandatory: false, sortingName: 'employeeComment' },
      { label: 'Finance comment', isMandatory: false, sortingName: 'financeComment' },
      { label: 'Approval', isMandatory: true, sortingName: 'approvalStatus' },
      { label: 'Action', isMandatory: false } // No sortingName needed for actions
    ];
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = { label: 'Manager comment', isMandatory: false, sortingName: 'managerComment' };
      const employeeCommentIndex = taskColumnHeaderInfoForFinanse.findIndex(column => column.sortingName === 'employeeComment');
      taskColumnHeaderInfoForFinanse.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }



    const taskColumnHeaderInfoForFinanceHRAdmin = [
      { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
      { label: 'Reimbursement type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'startDate' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: 'actualAmountByFinance' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'attachDocumentProof' },
      { label: 'Status', isMandatory: true, sortingName: 'status' },
      { label: 'Employee comment', isMandatory: false, sortingName: 'employeeComment' },
      { label: 'Finance comment', isMandatory: false, sortingName: 'financeComment' },
      { label: 'Approval', isMandatory: true, sortingName: 'approvalStatus' }
    ];
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = { label: 'Manager comment', isMandatory: false, sortingName: 'managerComment' };
      const employeeCommentIndex = taskColumnHeaderInfoForFinanceHRAdmin.findIndex(column => column.sortingName === 'employeeComment');
      taskColumnHeaderInfoForFinanceHRAdmin.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }
    this.taskColumnHeaderInfoForFinanse = (this.loggedInUserRole == 'HR Admin') ? taskColumnHeaderInfoForFinanceHRAdmin : taskColumnHeaderInfoForFinanse;

  }


  tableDataDetails: any = [];
  onSortAssending(sortKey: any): void {
    this.tableDataDetails.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
  }
  onSortDesending(sortKey: any): void {
    this.tableDataDetails.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] > b[sortKey]) return -1;
      if (a[sortKey] < b[sortKey]) return 1;
      return 0;
    });
  }
  getFormattedString(data: any): string {
    return data.length > 10 ? data.substring(0, 10) + '...' : data;
  }
  onRemoveUploadedFile(item: any) {
    item.documentAttachment = null;
  }
  selectALLTaskRecords(event: any) {
    if (event.checked) {
      this.selectedTaskList = [];
      this.selectAllTaskCheckbox = true;

      this.selectAllTaskCheckbox = false;
      this.selectedTaskList = [];
    }
  }



  // http://localhost:8085/api/uplodphoto/upload-file-locally
  allTeamReimbursement: any = [];
  allTeamMemberReimbursementApprove: any = [];
  currentallTeamMemberReimbursementApprove: any = [];
  allListingEmployeeId: any = [];
  allListingEmployeeIdForTeam: any = [];
  currrentTableDataDetails: any = [];
  fitergetAllFinanceUserDDHrAdmin: any = []
  // getAllEmployeeListinga() {
  //   this.httpService.callGetService(`${this.config.allReimbursementApplication}`)
  //     .subscribe((response: any) => {
  //       console.log(response)
  //     });
  //   }

  reimbursementData: any[] = [];
  getAllEmployeeListing() {

    // this.getAllEmployeeListinga()
    this.httpService.callGetService(`${this.config.allReimbursementApplication}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {

        this.tableDataDetails = [];
        this.allTeamMemberReimbursementApprove = [];
        this.allTeamReimbursement = [];

        const tableDataDetails = response.data;
        const managerEmployeId = this.EmployeeSummaryData.map((elm: any) => elm.id);
        this.httpService.setemployeData(managerEmployeId);
        this.httpService.setReimbursementData(response.data);
    
        // Immediately get the data if needed
        this.reimbursementData = this.httpService.getReimbursementData();
        console.log('Data after fetch:', this.reimbursementData);

        console.log("DELETE CALL"+ this.loggedInUserRole)
 
        console.log(this.loggedInUserRole)
        if ((this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'MD') && sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
          // For Finance/Manager Login
          console.log("For Finance Login")
          // For Team Reimbursement Condition here --- finance

          // My Reimbursement -- current user login only show Reimbursement data (as employee)
          tableDataDetails.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };

              // Check if employeeId already exists in the array (to avoid duplicates)
              let isDuplicateEmployee = this.allListingEmployeeId.some(
                (employee: { employeeId: any; }) => employee.employeeId === elm.employeeId
              );

              if (elm.approvedByManager === "APPROVED") {
                if (!isDuplicateEmployee) {
                  elm.financeStatus = elm.approvedStatus;
                  this.allListingEmployeeId.push(arrEmployeeList); //TODO : main problem
                }
              }
              // Avoid pushing duplicates into tableDataDetails
              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {
                this.tableDataDetails.push(elm);
              }
            }
          });



          // For Team Reimbursement Condition here --- mnanager/finanace
          tableDataDetails.forEach((elm: any, i: any) => {

            if (this.loggedInUserId != elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

              // Check if employeeId already exists in the array
              let isDuplicate = this.allListingEmployeeIdForTeam.some(
                (employee: { employeeId: any; }) => employee.employeeId === elm.employeeId
              );

              if (!isDuplicate) {
                this.allListingEmployeeIdForTeam.push(arrEmployeeList);
                this.allListingEmployeeIdForTeam = this.allListingEmployeeIdForTeam.filter((record: any) => managerEmployeId.includes(record.employeeId));
              }// select employee


              // this.allTeamReimbursement.push(elm);
              // Check for duplicates before adding
              const isDuplicatelist = this.allTeamReimbursement.some(
                (item: any) => item.reimbursementApplicationId === elm.reimbursementApplicationId
              );


              if (!isDuplicatelist) {
                elm.managerStatus = elm.approvedByManager;

                this.allTeamReimbursement.push(elm);

                this.allTeamReimbursement = this.allTeamReimbursement.filter((record: any) => managerEmployeId.includes(record.employeeId));

              }


            }
          })


          // For Team Reimburesement
          this.currrentTableDataDetails = this.allTeamReimbursement;

          
          // For Reimbursement Approve tab
          tableDataDetails.forEach((elm: any) => {
            // Add unique employee to allListingEmployeeId
            const arrEmployeeList = { employeeId: elm.employeeId, employeeName: elm.employeeName };
            
            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );


            // Filter and update approved reimbursements
            if (this.handalemployeToFinanceCondition == 'EMPLOYEE_TO_FINANCE') {
              if ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList); // TODO
                }
              }
            } else {
              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList); // TODO
                }
              }

            }
            elm.financeStatus = elm.approvedStatus; // status finance
            // console.log( elm.financeStatus);

            this.allTeamMemberReimbursementApprove.push(elm);


          });
          
          
          // Assign filtered approvals to currentallTeamMemberReimbursementApprove
          if (this.handalemployeToFinanceCondition == 'EMPLOYEE_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          } else {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
            );

          }
          // For Reimbursement Approve
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;


        } else if ((this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'MD') && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
          // For Manager Login
          console.log("For Manager Login")
          tableDataDetails.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };


              this.allListingEmployeeId.push(arrEmployeeList); // select employee

              // Avoid pushing duplicates into tableDataDetails
              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {
                this.tableDataDetails.push(elm);
              }
            }
          })



          this.currrentTableDataDetails = this.tableDataDetails;
          // For Team Reimbursement Condition here --- mnanager
          tableDataDetails.forEach((elm: any, i: any) => {

            if (this.loggedInUserId != elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }
              // this.allListingEmployeeIdForTeam.push(arrEmployeeList)
              // Check if employeeId already exists in the array before pushing
              if (!this.allListingEmployeeIdForTeam.find((employee: { employeeId: any; }) => employee.employeeId === elm.employeeId)) {
                this.allListingEmployeeIdForTeam.push(arrEmployeeList);
                this.allListingEmployeeIdForTeam = this.allListingEmployeeIdForTeam.filter((record: any) => managerEmployeId.includes(record.employeeId));

              }

              // this.allTeamReimbursement.push(elm);
              // Check for duplicates before adding
              const isDuplicatelist = this.allTeamReimbursement.some(
                (item: any) => item.reimbursementApplicationId === elm.reimbursementApplicationId
              );

              if (!isDuplicatelist) {
                elm.managerStatus = elm.approvedByManager;
                this.allTeamReimbursement.push(elm);

                this.allTeamReimbursement = this.allTeamReimbursement.filter((record: any) => managerEmployeId.includes(record.employeeId));
              }
            }
          })

          this.currrentTableDataDetails = this.allTeamReimbursement;
        } else if (this.loggedInUserRole === 'Employee') {
          console.log("Employee Login")


          tableDataDetails?.forEach((elm: any, i: any) => {

            if (this.loggedInUserId == elm.employeeId) {
              console.log("Emp In ");

              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

              // if (!this.allListingEmployeeId.find((employee: { employeeId: any; }) => employee.employeeId === elm.employeeId)) {
              //   this.allListingEmployeeId.push(arrEmployeeList);
              // }

              const isDuplicate = this.allListingEmployeeId?.some(
                (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
              );

              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList);
                }
              }

              // Avoid pushing duplicates into tableDataDetails

              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {

                this.tableDataDetails.push(elm);
              }
            }
          });

          this.currrentTableDataDetails = this.tableDataDetails;   // For Employee


          // For Reimbursement Approve tab
          tableDataDetails.forEach((elm: any) => {
            // Add unique employee to allListingEmployeeId
            const arrEmployeeList = { employeeId: elm.employeeId, employeeName: elm.employeeName };

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );

            console.log("KKK");


            // Filter and update approved reimbursements
            if (this.handalemployeToFinanceCondition == 'EMPLOYEE_TO_FINANCE') {
              if ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList);
                }
              }
            } else {
              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList);
                }
              }

            }


            if (elm.approvedStatus == 'PENDING') {
              elm.approvedStatus = 'PENDING';
            } else if (elm.approvedStatus == 'REJECTED') {
              elm.approvedStatus = elm.approvedStatus;
              elm.financeStatus = elm.approvedStatus;
            } else {
              elm.approvedStatus = 'APPROVED';
              elm.financeStatus = elm.approvedStatus;
            }

            this.allTeamMemberReimbursementApprove.push(elm);
          });



          if (this.handalemployeToFinanceCondition == 'EMPLOYEE_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          } else {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
            );

          }
          // For Reimbursement Approve
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;



        } else {
          console.log("Other Login")
          console.error(tableDataDetails)
          // allTeamMemberReimbursementApprove // for HR Admin

          tableDataDetails.forEach((elm: any, i: any) => {

            var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );
            // Filter for finance
            if (elm.approvedStatus == 'APPROVED' || elm.approvedStatus == 'REJECTED') {
              if (!isDuplicate) {
                this.fitergetAllFinanceUserDDHrAdmin.push(elm.financeId)
              }
            }


          })
          setTimeout(() => {

            const matchingUsers = this.getAllFinanceUserDD.filter((user: any) => this.fitergetAllFinanceUserDDHrAdmin.includes(user.id));

            this.fitergetAllFinanceUserDD = matchingUsers;

            this.allTeamMemberReimbursementApprove = tableDataDetails

            // this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
            //   (elm: any) => (elm.approvedStatus === "APPROVED")
            // );

            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
            this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;


          }, 800)
        }


      });
  }
  addKPISPopup(event: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '80%';   // Try setting width to a smaller value
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      fromYear: this.fromYear,
      toYear: this.toYear,
      data: event,
      year: this.selectedYearForCompetency,

    };

    const dialogRef = this.dialog.open(AddExpenseEmployeeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAllEmployeeListing();
    });
  }

  getAllEmployeeListingforEmployeToFinance() {
    this.httpService.callGetService(`${this.config.allReimbursementApplicationForEmployeeToFinance}`)
      .subscribe((result: any) => {
        this.tableDataDetails = result;

        this.tableDataDetails.forEach((elm: any, i: any) => {
          if (elm.uploadDocument) {
            this.tableDataDetails[i].uploadDocument = `${this.config.downloadFile}${elm.uploadDocument}`;
          }
        })


      });
  }
  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }


  deleteEmployee(event: any) {
    // Open the confirmation popup
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you want to Delete?',
        btn1: 'No',
        btn2: 'Yes',
      },
    });

    // Handle the result of the popup
    dialogRef.afterClosed().subscribe((result) => {
      if (result) { // Only proceed if user confirms deletion
        this.httpService.callDeleteService(`${this.config.reimbursementsApplications}/${event}`)
          .subscribe({
            next: (result) => {
              if (result) {
                // Show a success message
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'Record deleted successfully.',
                    btn2: 'OK',
                  },
                }).afterClosed().subscribe(() => {
                  console.log("Calling delete function")
                  this.getAllEmployeeListing(); // Refresh the list after deletion
                });
              }
            },
            error: (err) => {
              console.error("Error deleting the data:", err);
              // Show an error popup
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'Failed to delete data. Please try again.',
                  btn2: 'OK',
                },
              });
            }
          });
      }
    });
  }
  // ------------------------------------------Manager--------------------------------------------------


  ApprovelStatus: any;
  isChecked: boolean = false;

  updateData: any;




  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;


    })
  }
  // 
  // You can use this variable to perform logic when the toggle changes
  toggleChanged() {
    console.log("Toggle is now", this.isChecked ? "Approve" : "Reject");
  }

  managergetData(row: any) {

    this.updateData = row;

  }

  updateManager() {
    let formData = {
      "managerComment": this.updateData.managerComment,
      "status": (this.updateData.approvedByManager == null) ? 'PENDING' : this.updateData.approvedByManager,
      "managerId": parseInt(this.loggedInUserId)
    }
    this.httpService.callPutService(`${this.config.reimbursementsUpdateManager}/${this.updateData.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {


          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: 'Reimbursement Application  data updated by Manager Successfully',
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe((result) => {
            this.getAllEmployeeListing();
            this.editedIndividualScoreId = null;
            this.onCheckIconView = false;
            this.isFormDisabled = false;
          });



        } else {

        }



      })
  }
  // ------------------------------------------Finanse--------------------------------------------------




  employeDDFoeHrAdmin: any[] = [];
  getAllEmployeesByDept() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "department": null,
      "departments": ["Operations", "Product", "Sales"],
      "from": "October-December",
      "fromYear": "2024",
      "to": "October-December",
      "toYear": "2024"
    }
    this.httpService.callPostService(this.config.getEmpsByDeptByDate, request).subscribe((data: any) => {
      this.employeDDFoeHrAdmin = data.data;

    })
  }
  empyforApprove: any = 'Select All Employee';
  getEmployeeForReimbursement(event: any): void {

    if (event == '-1') {
      this.allTeamReimbursement = this.currrentTableDataDetails;
    } else {
      // Use the original array to filter and update `tableDataDetails`.
      const updatedTableDataDetails = this.currrentTableDataDetails.filter((elm: any) => {

        return elm.employeeId === event;
      });

      // If matches are found, update the array with the new one.
      if (updatedTableDataDetails.length > 0) {

        this.allTeamReimbursement = updatedTableDataDetails;
      }

    }
  }

  financeIdForEmployee: number = -1; // Default value

  getEmployeeForReimbursementApprove(event: any): void {

    if (this.loggedInUserRole != 'HR Admin') {

      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
      } else {
        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => {

          return elm.employeeId === event;
        });

        // If matches are found, update the array with the new one.
        if (updatedTableDataDetails.length > 0) {

          this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
        }

      }
    } else {


      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
      } else {
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => (elm.financeId == this.financeIdForEmployee && elm.employeeId == event));

        this.allTeamMemberReimbursementApprove = data;
      }
    }




  }
  selectedEmployeeForFinance: any = -1;
  // For Select Finance 
  
  getFinaceForReimbursement(event: any) {
    if (this.loggedInUserRole != 'HR Admin') {

      if (event == '-1') {
        this.tableDataDetails = this.currrentTableDataDetails;
      } else {
        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = this.currrentTableDataDetails.filter((elm: any) => {

          return elm.employeeId === event;
        });

        // If matches are found, update the array with the new one.
        if (updatedTableDataDetails.length > 0) {

          this.tableDataDetails = updatedTableDataDetails;
        }

      }
    } else {
      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
        this.allListingEmployeeId = [];
        this.selectedEmployeeForFinance = -1;
         this.isShowEmployee = false;
      } else {
        this.isShowEmployee = true;
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.financeId == event);
        this.selectedEmployeeForFinance = -1;
        this.allListingEmployeeId = data;
        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = data.filter((elm: any) => elm.financeId === event);
        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
      }

    }

    //check user list by finance admin


  }

  updateFinance() {
    if (this.updateData.approvedStatus != 'REJECTED') {
      if (this.updateData.assignedAmount == null) {
        this.showToast('Assigned Amount Is Required', 'danger');
        return;
      }
    }
    let formData = {
      "financeComment": this.updateData.financeComment,
      "approvedStatus": this.updateData.approvedStatus,
      "assignedAmount": this.updateData.assignedAmount,
      "financeId": parseInt(this.loggedInUserId)
    }

    this.httpService.callPutService(`${this.config.reimbursementsUpdateFinance}/${this.updateData.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {


          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: 'Reimbursement Application  data updated by Finance Successfully',
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe((result) => {
            this.getAllEmployeeListing();
            this.editedIndividualScoreId = null;
            this.onCheckIconView = false;
            this.isFormDisabled = false;
          });



        } else {

        }



      })
  }
  filteredData: any[] = [];
  searchTaskString: string = '';
    onSearchTask(searchString: string) {

          if (this.loggedInUserRole == 'Employee') {

      let seacrhData = this.tableDataDetails;
      if (searchString == '') {

        this.getAllEmployeeListing();
        this.tableDataDetails = [...this.tableDataDetails]; // Update tableDataDetails with full data
      } else {
        // Filter rows based on the search string matching any of the fields
        this.filteredData = seacrhData.filter((row: any) =>
          (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
          (row.actualAmount && row.actualAmount.toString().includes(searchString))
          ||
          (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
          ||
          (row.status && row.status.toString().includes(searchString))
          ||
          (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
        );

        this.tableDataDetails = [...this.filteredData];

      }
    }

    }  
}